export default class Menus {
	constructor() {
		this.mobileMenu = document.getElementById("mobile-menu");
		this.menuIconOpen = document.getElementById("menu-icon--open");
		this.menuIconClose = document.getElementById("menu-icon--close");
		this.headerAll = document.getElementById("header__all");

		this.onClickBurger = this.onClickBurger.bind(this);
		// this.onClickOverlay = this.onClickOverlay.bind(this);

		vb.headerBurger.addEventListener("click", this.onClickBurger);
		// this.overlay.addEventListener('click', this.onClickOverlay);
	}

	onClickBurger() {
		this.mobileMenu.classList.toggle("hidden");
		this.menuIconOpen.classList.toggle("hidden");
		this.menuIconClose.classList.toggle("hidden");
		this.headerAll.classList.toggle("fixed");
		// document.body.classList.toggle('mobile-menu-open');
		// vb.header.classList.remove('header--search');
	}

	onClickOverlay(e) {
		// if (document.body.classList.contains('mobile-menu-open')) {
		// 	this.onClickBurger();
		// }
	}
}
